var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 37.2085C25.1894 35.7471 21.2621 35.5223 17.6621 36.534C15.153 37.2085 12.7529 38.5574 10.5711 40.2436L9.04378 41.5926L8.60742 42.0422L9.58924 42.9415C9.69833 42.9415 9.69835 43.0539 9.80744 43.1663C10.0256 43.3912 10.2438 43.5036 10.5711 43.7284L11.2256 44.178L11.8802 43.616C11.9893 43.5036 12.2075 43.2788 12.4256 43.1663C14.3893 41.4802 16.5711 40.356 18.8621 39.794C21.8075 39.0071 24.9712 39.1195 28.1349 40.356C30.7531 41.3677 36.0986 42.6043 42.535 39.794L42.7532 39.6816L43.0805 39.3443C43.0805 39.2319 43.1896 39.2319 43.2987 39.1195C43.8441 38.445 44.3896 37.7706 44.8259 36.9837L47.0078 33.4989L43.5168 35.5223C38.3895 38.445 33.6986 39.0071 29.0076 37.2085Z",
    fill: "url(#paint0_linear_612_339)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0609 25.068C17.0064 24.2811 20.1701 24.3935 23.3337 25.63C26.8247 26.979 35.7702 28.89 45.8067 19.5598L47.443 17.8736L47.5521 17.7612L47.9885 17.3115L47.7703 16.7495C47.6612 16.2998 47.443 15.7378 47.2248 15.1757L46.6794 13.6019L45.5885 14.726C45.4794 14.9509 45.2612 15.0633 45.043 15.2881C40.243 20.3466 32.8247 25.5176 24.3155 22.3701C20.4973 20.9087 16.57 20.6839 12.97 21.6956C9.47906 22.7073 6.42448 24.6183 3.58809 27.3162L3.33911 27.5744L1.95171 29.0024C1.95171 29.0024 1.84264 29.1148 1.73355 29.2272L1.40625 29.5644L1.51535 30.0141C1.62444 30.5761 1.84262 31.1382 1.95171 31.7003L2.60627 33.4989L3.69719 32.0375C3.80628 31.8127 4.02446 31.7003 4.13355 31.4755C6.42448 29.3396 9.58815 26.3045 14.0609 25.068Z",
    fill: "url(#paint1_linear_612_339)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47956 23.0444C5.98867 20.3465 8.82504 18.6604 11.8796 17.7611C14.8251 16.9742 17.9888 17.0866 21.1524 18.3231C30.9707 22.0327 39.4799 15.9625 43.189 12.7025L44.6072 11.2412L45.1526 10.7915L44.7163 10.1171C44.389 9.77982 44.1708 9.33017 43.8436 8.88052L43.189 7.9812L42.4254 8.7681C42.3163 8.88051 42.0981 9.10533 41.989 9.21774C37.4071 13.7142 30.3161 18.3231 22.2433 15.1756C18.4251 13.7142 14.4978 13.4894 10.8978 14.5011C8.60687 15.1756 6.42502 16.2997 4.24318 17.7611L1.95225 19.6721C1.73406 19.8969 1.62497 20.0093 1.40679 20.2341L1.18862 20.4589V20.7962C1.07953 21.5831 1.07952 22.37 0.970427 23.0444L0.861328 25.8547L2.7159 23.8313C2.93409 23.6065 3.15228 23.2693 3.47956 23.0444Z",
    fill: "url(#paint2_linear_612_339)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9523 43.8407C23.5524 42.829 32.0816 43.4042 36.4252 45.9764L33.3707 47.1007C32.7161 47.4379 31.8434 47.6627 31.0797 47.8876L30.7525 48L30.207 47.7752C29.8797 47.6628 29.6615 47.5503 29.3342 47.4379C26.2797 46.4262 23.6571 46.468 18.8614 47.7752L18.5342 47.6627L16.5705 46.9883L14.3887 46.2014L15.0432 45.8642L17.6614 44.6276C18.425 44.2904 19.1885 44.0656 19.9521 43.8408L19.9523 43.8407Z",
    fill: "url(#paint3_linear_612_339)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8613 21.5831L47.2249 23.2693C47.0068 23.4941 46.7886 23.719 46.5704 23.9438C42.0976 28.3279 34.8976 33.0491 26.8248 29.9016C23.0066 28.4403 19.0793 28.2155 15.4792 29.2272C12.0974 30.2389 9.04278 32.0375 6.31548 34.7353L4.8973 36.3091L4.46094 36.8712L4.8973 37.5456C5.22457 37.9953 5.44277 38.3325 5.66096 38.7822L6.31548 39.7939L7.07914 38.7822C7.18823 38.6698 7.40641 38.4449 7.5155 38.3325C10.1337 35.4098 12.9701 33.6112 16.2428 32.7119C19.1883 31.925 22.352 32.0374 25.5157 33.274C28.243 34.2857 31.0794 34.6229 33.9158 34.2857C38.934 33.7236 43.9522 30.8009 47.6613 27.541C47.8795 27.3162 48.0977 27.2038 48.3159 26.9789L48.6432 26.6417V26.3044C48.6432 25.63 48.7523 24.8431 48.7523 24.1686L48.8613 21.5831Z",
    fill: "url(#paint4_linear_612_339)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7523 11.0164C15.5887 9.7799 12.425 9.66749 9.47953 10.4544C9.23807 10.4544 7.12435 11.2038 6.09768 11.5785L2.71582 13.3771L4.78856 10.1171C5.22493 9.44268 5.77041 8.8806 6.20677 8.20613C11.7636 6.63825 15.916 6.29513 19.8433 7.75649C25.2979 9.89232 31.0797 8.65577 36.8616 4.15929C37.0798 4.04688 37.1888 3.82206 37.407 3.70965L37.9525 3.26001L38.607 3.70965C39.0434 3.93447 39.4798 4.2717 39.8071 4.60893L40.7889 5.39583L40.2434 5.84547L38.607 7.19443C34.3525 10.4544 29.7706 12.1406 25.1888 12.1406C22.8978 12.1406 20.8251 11.8033 18.7523 11.0164Z",
    fill: "url(#paint5_linear_612_339)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0079 4.8337C20.2806 4.8337 17.9896 4.54209 12.8623 2.69788L15.3714 1.57376C16.026 1.23652 16.6805 1.01169 17.3351 0.786863L17.6624 0.674444L17.9896 0.786863L18.9715 1.12412C22.1351 2.02342 25.4079 1.79859 28.6806 0.56206C29.0079 0.449648 29.3352 0.224797 29.6625 0.112385L29.9897 0H30.317C31.0806 0.112412 31.7352 0.337236 32.3898 0.56206L34.6807 1.34892L31.2989 3.0351C28.5716 4.15922 25.8443 4.8337 23.0079 4.8337Z",
    fill: "url(#paint6_linear_612_339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_612_339",
    x1: 27.8076,
    y1: 33.4989,
    x2: 27.8076,
    y2: 44.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_612_339",
    x1: 24.6974,
    y1: 13.6019,
    x2: 24.6974,
    y2: 33.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_612_339",
    x1: 23.007,
    y1: 7.9812,
    x2: 23.007,
    y2: 25.8547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_612_339",
    x1: 25.4069,
    y1: 43.3695,
    x2: 25.4069,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_612_339",
    x1: 26.6611,
    y1: 21.5831,
    x2: 26.6611,
    y2: 39.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_612_339",
    x1: 21.7524,
    y1: 3.26001,
    x2: 21.7524,
    y2: 13.3771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_612_339",
    x1: 23.7715,
    y1: 0,
    x2: 23.7715,
    y2: 4.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.facd9c490972ecd042abca291f674a09.svg";
export { ForwardRef as ReactComponent };